export const removeRouteQuery = async (paramName: string) => {
  const $router = useRouter();
  const query = { ...$router.currentRoute.value.query };

  if (paramName in query) {
    delete query[paramName];
    return navigateTo({ query, replace: true });
  }
};
